import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {

  transform(empList: any[], prop: string, str: string): any[] {
    if (!empList || !Array.isArray(empList)) {
      return [];
    }
    if (!str || !str.trim()) {
      return empList;
    }
    const searchStr = str.toLowerCase().trim();
    return empList.filter(x => {
      if (!x) return false;
      const val = x[prop] || x.EmpName || x.Emp_Name || x.FullName || x.Name || '';
      return String(val).toLowerCase().includes(searchStr);
    });
  }

}
